import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode:"history",
  routes: [
    {
      path: '/404',
      component: () => import( '../view/error.vue'),
      hidden: true
    }, 
    {
      path: '/',
      // name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, 
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/index'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/lodges',
          name: 'lodges',
          component: resolve => require(['@/view/lodges'], resolve),
        },
        {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/about'], resolve),
        },
        {
          path: '/contact',
          name: 'contact',
          component: resolve => require(['@/view/contact'], resolve),
        }
      ]
    }, 
    { path: '*',
      redirect: '/404', 
      hidden: true 
    }
  ]
})
router.beforeEach((to,from,next) => {
  console.log(to,'ssssssssssss');
  // 路由发生变化修改页面的title
  // if(to.name == 'home') {
  //   document.title = 'Relbia Lodge'
  // }else {
  //   document.title = to.name + '-' +'Relbia Lodge'
  // }
  document.title = to.name == 'home' ? 'Relbia Lodge' : to.name + '-' +'Relbia Lodge'
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js